export default class CommonGetters {
  static getDoorPartLabel (doorPartIndex, allPartsCount) {
    if (allPartsCount === 1) {
      return '';
    }

    if (doorPartIndex === 0) {
      return 'Top';
    }

    if (doorPartIndex === allPartsCount - 1) {
      return 'Bund'
    }

    return 'Midter'
  };
  static formatDateForDisplay (value, emptyTxt = '-') {
    if (!value) {
      return emptyTxt;
    }

    let newDate = new Date(value);

    let datePart = [
      newDate.getDate(),
      newDate.getMonth() + 1,
      newDate.getFullYear()
    ]
      .map(n => (n < 10 ? '0' + n : n))
      .join('.');

    return datePart;
  }

  static formatDateTimeForDisplay (value, emptyTxt = '-') {
    if (!value) {
      return emptyTxt;
    }

    let newDate = new Date(value);

    let datePart = [
      newDate.getDate(),
      newDate.getMonth() + 1,
      newDate.getFullYear()
    ]
      .map(n => (n < 10 ? '0' + n : n))
      .join('.');

    let timePart = [
      newDate.getHours(),
      newDate.getMinutes()
    ]
      .map(n => (n < 10 ? '0' + n : n))
      .join(':');

    return `${datePart} ${timePart}`;
  }
}
